import { LegalPage } from '@startus/ui';
import { privacyPolicy } from '@startus/content';

export function PrivacyPolicyPage() {
  return <LegalPage content={privacyPolicy} />;
}
